import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import Company from "@/pages/Company";
import Upload from "@/pages/Upload";
import Reports from "@/pages/Reports";
import ReportDetail from "@/pages/ReportDetail";
import Settings from "@/pages/Settings";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Team from "@/pages/Team";

function withLayout(Page) {
    return (
        <ProtectedRoute>
            <Layout>
                <Page />
            </Layout>
        </ProtectedRoute>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={withLayout(Dashboard)} />
                    <Route path="/companies" element={withLayout(Companies)} />
                    <Route path="/companies/:slug" element={withLayout(Company)} />
                    <Route path="/upload" element={withLayout(Upload)} />
                    <Route path="/reports" element={withLayout(Reports)} />
                    <Route path="/reports/:id" element={withLayout(ReportDetail)} />
                    <Route path="/team" element={withLayout(Team)} />
                    <Route path="/settings" element={withLayout(Settings)} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
